// MUI
import { Grid, Stack, SvgIcon, Typography } from "@mui/material";

// CUSTOM COMPONENTS
import DoubleCheckingButton from "@/Layouts/components/Buttons/DoubleCheckingButton";
import QueuePositionUser from "./QueuePositionUser";

// TYPES
import { IPositionQueue, IUserQueue } from "@/Settings/types/QueueMapping/QueueMapping";

// ICONS
import { ReactComponent as TrashIcon } from "@/assets/icons/actions/trash.svg";

interface IQueuePositionProps {
	position: IPositionQueue;
	selectedUsers: IPositionQueue[];
	onDeleteAllMembers: (positionId: string) => void;
	handleSelectUser: (position: string, user: IUserQueue) => void;
}
const QueuePosition = (props: IQueuePositionProps) => {
	const { position, selectedUsers, onDeleteAllMembers, handleSelectUser } = props;
	const { users } = position;

	return (
		<>
			<Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"flex-start"}>
				<Typography className="regular-montserrat-label fs-18">{position.name}</Typography>
				<DoubleCheckingButton
					title={"Remove All members"}
					endIcon={<SvgIcon className="!text-[16px] ml-[4px]" component={TrashIcon} viewBox={"0 0 14 14"} />}
					confirmationButtonClasses={"btn-table-confirmation-remove"}
					mainButtonClasses={"btn-simple-remove btn-pack-remove"}
					disabled={false}
					mainSx={{ marginLeft: "10px" }}
					confirmationSx={{ right: 0, left: "10px", width: "172px !important" }}
					onDeleteAction={() => onDeleteAllMembers(position._id)}
				/>
			</Stack>
			<Grid container className="grid-cols-4" rowGap={1} columnGap={4}>
				{users.map((user) => (
					<Grid item key={user._id} mt={1}>
						<QueuePositionUser
							position={position.name}
							user={user}
							selectedUsers={selectedUsers}
							handleSelectUser={handleSelectUser}
						/>
					</Grid>
				))}
			</Grid>
		</>
	);
};

export default QueuePosition;
